import { MatInputModule } from "@angular/material/input";
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { Watch } from "../../shared/models/watch";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { Brand } from "../../shared/models/brand";
import { map, Observable, startWith } from "rxjs";
import { BrandService } from "../../shared/services/brand.service";
import { MatAutocompleteModule, MatAutocompleteSelectedEvent } from "@angular/material/autocomplete";
import { MatIconModule } from "@angular/material/icon";
import { MainMenuComponent } from "../../layout/main-menu/main-menu.component";

@Component({
  selector: "app-publish-watch",
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    MatInputModule,
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatAutocompleteModule,
    MatIconModule,
    MainMenuComponent,
    MainMenuComponent,
  ],
  standalone: true,
  templateUrl: "./publish-watch.component.html",
  styleUrls: ["./publish-watch.component.scss"],
})
export class PublishWatchComponent implements OnInit {
  watchForm: FormGroup;
  photos: string[] = [];
  brands: Brand[] = [];
  @ViewChild("fileInput") fileInput!: ElementRef;
  filteredBrands$: Observable<Brand[]> = new Observable();

  constructor(private fb: FormBuilder, private brandService: BrandService) {
    this.watchForm = this.fb.group({
      name: ["", Validators.required],
      brandId: [null, Validators.required],
      watchCondition: [null, Validators.required],
      price: [null, [Validators.required, Validators.min(0)]],
      description: [""],
    });
  }

  ngOnInit(): void {
    this.buildForm();
    this.loadBrands();
  }

  private buildForm(): void {
    this.watchForm = this.fb.group({
      name: ["", [Validators.required, Validators.minLength(3)]],
      brand: ["", Validators.required], // Campo visible
      brandId: [null, Validators.required], // Se llena con el ID real
      watchCondition: [null, Validators.required],
      price: ["", [Validators.required, Validators.min(1)]],
      description: ["", [Validators.maxLength(500)]],
    });
  }

  private loadBrands(): void {
    this.brandService.getBrands().subscribe((page) => {
      this.brands = page.content;
      this.filteredBrands$ = this.watchForm.controls["brand"].valueChanges.pipe(
        startWith(""),
        map((value) => this.filterBrands(value || ""))
      );
    });
  }

  private filterBrands(value: string): Brand[] {
    const filterValue = value.toLowerCase();
    return this.brands.filter((brand) => brand.name.toLowerCase().includes(filterValue));
  }

  onBrandSelected(event: MatAutocompleteSelectedEvent): void {
    const selectedBrandName = event.option.viewValue;
    const selectedBrand = this.brands.find((brand) => brand.name === selectedBrandName);

    if (selectedBrand) {
      this.watchForm.patchValue({ brandId: selectedBrand.id });
    }
  }

  onSubmit(): void {
    if (this.watchForm.invalid) {
      this.watchForm.markAllAsTouched();
      return;
    }

    const watchData: Watch = {
      ...this.watchForm.value,
      images: this.photos,
    };
  }
  openFileSelector(): void {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const files = input.files;

    if (files) {
      // Convierte los archivos a base64 y agrégales a las fotos
      Array.from(files).forEach((file) => {
        const reader = new FileReader();
        reader.onload = () => {
          if (reader.result) {
            this.photos.push(reader.result as string); // Agrega la URL base64 al array de fotos
          }
        };
        reader.readAsDataURL(file); // Convierte el archivo a base64
      });
    }
  }
  removePhoto(index: number): void {
    // Elimina la foto del array en la posición correspondiente
    this.photos.splice(index, 1);
  }
  getErrorMessage(field: string): string {
    const control = this.watchForm.get(field);
    if (control?.hasError("required")) return "This field is required";
    if (control?.hasError("minlength")) return "Must be at least 3 characters";
    if (control?.hasError("min")) return "Price must be a positive number";
    if (control?.hasError("maxlength")) return "Maximum 500 characters allowed";
    return "";
  }
}
